import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';

interface ProtectedRouteProps {
 children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
 const { user, isLoading } = useAuth();
 const location = useLocation();

 if (isLoading) {
  return (
   <div className='min-h-screen flex items-center justify-center'>
    <div className='text-center'>
     <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto'></div>
     <p className='mt-2 text-sm text-muted-foreground'>Loading...</p>
    </div>
   </div>
  );
 }

 if (!user) {
  return <Navigate to='/login' replace />;
 }

 const isOnboarding = location.pathname === '/onboarding';

 if (!user.onboardingCompleted && !isOnboarding) {
  return <Navigate to='/onboarding' replace />;
 }

 if (user.onboardingCompleted && isOnboarding) {
  return <Navigate to='/dashboard' replace />;
 }

 return <>{children}</>;
}
